import React, {type PropsWithChildren} from 'react';
import dynamic from 'next/dynamic';
import ApiProvider from '@deezer/react-legacy-api';
import {config} from '@modules/config';
import ThemeProvider from '@providers/ThemeProvider';

const DynamicPerformanceMonitoring = dynamic(() =>
	import('./PerformanceMonitoring').then(
		({PerformanceMonitoring}) => PerformanceMonitoring,
	),
);

const DynamicAppClub = dynamic(() => import('./AppClub'));

export type Webview = 'club';

type AppRootProps = PropsWithChildren<{
	webview?: Webview;
}>;

const AppRoot: React.FC<AppRootProps> = ({webview, children}) => {
	return (
		<ThemeProvider>
			<ApiProvider
				host={config.get('host_website_ssl')}
				mode="cors"
				credentials="include"
			>
				<DynamicPerformanceMonitoring />
				{webview === 'club' ? (
					<DynamicAppClub>{children}</DynamicAppClub>
				) : (
					children
				)}
			</ApiProvider>
		</ThemeProvider>
	);
};

export default AppRoot;
